import { graphql } from "gatsby";
import { marked } from "marked";
import React from "react";

import { TypeForm } from "../../modules/Forms/domain/Forms";
import { BasicForm } from "../../modules/Forms/Views/Basic/BasicForm";
import withForm from "../../modules/Forms/withForm";
import Markdown from "../../modules/Markdown/Markdown";
import SocialLinksList from "../../modules/SocialsLinks/SocialLinksList";
import { ISliceProps } from "../../types/thecookies";

export const ContactUs = (props: ISliceProps<Queries.ContactUsQuery>) => {
  const BasicFormUse = withForm(BasicForm, TypeForm.BASIC, "footer", "white");
  const renderer = new marked.Renderer();
  renderer.paragraph = (text) => {
    return `<p class="m-contact-us__text">${text}</p>`;
  };
  return (
    <section className={"o-contact-form o-contact-us "} id="contact">
      <div className={"c-contact-us"}>
        <div className={"m-contact-us__header-bottom"}>
          <div>
            <h2>
              {props.data?.shared?.contactUs?.index} <br />
              <span className="subtitle lighter">
                {props.data?.shared?.contactUs?.title}
              </span>
            </h2>
            <Markdown
              markdown={props.data?.shared?.contactUs?.text}
            />
            
          </div>
          <SocialLinksList
            socialLinkList={
              props.data?.sanitySetting?.socialLinks?.map(
                (item: string | null) => {
                  return {
                    url: item || "",
                  };
                },
              ) || []
            }
          />
        </div>
        <BasicFormUse />
      </div>
      <div className={"c-contact-us"}>
        <div className={"m-contact-us__footer-bottom"}>
          <a
            href={`tel:+34${props.data?.sanitySetting?.phone}`}
            target="_blank"
            rel="noreferrer"
          >
            {props.data?.sanitySetting?.phone}
          </a>
          <a
            href={`${props.data?.sanitySetting?.googleMapsUrl}`}
            target="_blank"
            rel="noreferrer"
          >
            {props.data?.sanitySetting?.postalAddress}
          </a>
          <a
            href={`mailto:${props.data?.sanitySetting?.email}`}
            target="_blank"
            rel="noreferrer"
          >
            {props.data?.sanitySetting?.email}
          </a>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;

export const query = graphql`
  query ContactUs($language: String!) {
    shared: sanityShared(language: { eq: $language }) {
      contactUs {
        index
        title
        text
      }
    }
    sanitySetting {
      socialLinks
      postalAddress
      googleMapsUrl
      phone
      email
    }
  }
`;
